export default __webpack_public_path__ + "static/media/progress-1.bafbf823.svg";